// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AutoDeliveryAndCarriersDataModel } from "@guestsupply/App/Components/Product/AutoDeliveryLink";
import { AutoDeliveryItemModel, GetEstimateTotalsModel } from "@guestsupply/App/Services/AutoDelivery";
import { BackOrderModel } from "@guestsupply/App/Services/BackorderManagementService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {}

type HandlerType = Handler<Parameter>;

export const DispatchCompleteSetAutoDeliveryModalClosed: HandlerType = props => {
    props.dispatch({
        type: "xAutoDelivery/CompleteSetModalClosed",
    } as any);
};

export const chain = [DispatchCompleteSetAutoDeliveryModalClosed];

const setAutoDeliveryModalClosed = createHandlerChainRunner(chain, "setAutoDeliveryModalClosed");
export default setAutoDeliveryModalClosed;
